import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
      <nav className="px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src="https://public.readdy.ai/ai/img_res/9b8ad5e9-7776-4335-9226-dc7b664815de.png" alt="El Paso Contractors" className="h-12 w-auto" />
          </a>
          
          <div className="hidden md:flex items-center gap-8">
            <a href="#services" className={`text-sm font-medium transition-colors hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Services
            </a>
            <a href="#neighborhoods" className={`text-sm font-medium transition-colors hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Neighborhoods
            </a>
            <a href="#guides" className={`text-sm font-medium transition-colors hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Guides
            </a>
            <a href="#contractors" className={`text-sm font-medium transition-colors hover:text-teal-600 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Find Contractors
            </a>
            <a href="#list-service" className="px-5 py-2 bg-teal-600 text-white text-sm font-medium rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
              List Your Service
            </a>
          </div>

          <button className="md:hidden text-white">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </nav>
    </header>
  );
}
